// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let HighlightSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ConversationPageSelectedConversationAnonymousControl_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationAnonymousControl_conversation_graphql.bs.js");
let ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql = require("../../../__generated__/ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.bs.js");

let convertFragment = ConversationPageSelectedConversationAnonymousControl_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

let ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertVariables;

let convertResponse = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

let DeanonymizeConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function ConversationPageSelectedConversationAnonymousControl(props) {
  let conversationId = props.conversationId;
  let conversation = RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, props.conversation);
  let anonymous = Stdlib_Option.getOr(conversation.anonymous, false);
  let match = use$1();
  let deanonymizeConversation = match[0];
  let currentUserId = AuthSession.useCurrentUserId();
  let match$1 = React.useState(() => false);
  let setShowConfirmation = match$1[1];
  let openDialog = param => setShowConfirmation(param => true);
  let closeDialog = param => setShowConfirmation(param => false);
  let match$2 = SystemMessages.useSystemMessages();
  let addMessage = match$2.addMessage;
  let showErrorMessage = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem sharing your information", 5000, undefined, undefined));
  let handleShareIdentity = param => {
    setShowConfirmation(param => false);
    if (conversationId !== undefined) {
      deanonymizeConversation({
        conversationId: conversationId
      }, undefined, undefined, undefined, (response, _mutationErrors) => {
        let match = response.deanonymizeConversation;
        if (match !== undefined && match.__typename === "ConversationWasDeanonymized") {
          return;
        } else {
          return showErrorMessage();
        }
      }, param => showErrorMessage(), undefined);
      return;
    }
  };
  let match$3 = conversation.conversationContext;
  let ownerAgentId;
  if (match$3 !== undefined && match$3.__typename === "AvailableConversationContext") {
    let match$4 = match$3.context;
    if (match$4 !== undefined) {
      switch (match$4.__typename) {
        case "ForSalePropertyV5" :
          let match$5 = match$4.agentV2;
          if (match$5 !== undefined && match$5.__typename === "VisibleForSalePropertyAgent") {
            let match$6 = match$5.agent;
            ownerAgentId = match$6 !== undefined ? match$6.id : undefined;
          } else {
            ownerAgentId = undefined;
          }
          break;
        case "RentalPropertyV5" :
          let match$7 = match$4.agent;
          ownerAgentId = match$7 !== undefined ? match$7.id : undefined;
          break;
        case "__unselected" :
          ownerAgentId = undefined;
          break;
      }
    } else {
      ownerAgentId = undefined;
    }
  } else {
    ownerAgentId = undefined;
  }
  if (anonymous && ownerAgentId !== undefined && currentUserId !== undefined && currentUserId === ownerAgentId) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(DialogV5.make, {
          title: "Share information?",
          isOpen: match$1[0],
          ariaLabel: "Are you sure?",
          onDismiss: closeDialog,
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: "This action cannot be undone."
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: closeDialog,
                    children: "Cancel"
                  }),
                  JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                    onClick: handleShareIdentity,
                    children: "Yes, share my identity"
                  })
                ],
                className: "flex flex-row justify-center space-x-4"
              })
            ],
            className: "flex flex-col items-center space-y-4"
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(HighlightSection__Jsx3.make, {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: "You are anonymous to other users in this conversation."
                }),
                conversationId !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                      onClick: openDialog,
                      children: "Share my identity"
                    })
                  }) : null
              ],
              className: "flex flex-col items-center space-y-2"
            })
          }),
          className: "p-4"
        })
      ]
    });
  } else {
    return null;
  }
}

let make = ConversationPageSelectedConversationAnonymousControl;

exports.ConversationFragment = ConversationFragment;
exports.DeanonymizeConversationMutation = DeanonymizeConversationMutation;
exports.make = make;
/* commitMutation Not a pure module */
